var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-container"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.franchiseLogo}}),_c('div',{staticClass:"menu-banner",style:('background-image: url(\'' + _vm.franchiseBanner + '\')')})])}
var staticRenderFns = []

export { render, staticRenderFns }